import * as React from 'react';
import { getDeployment } from '@/redux/modules/config';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useScript } from 'use-script';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import usePrevious from '@liveauctioneers/caterwaul-components/lib/hooks/usePrevious';

type Props = {
    baseUrl: string;
    catalogId: number;
    setZipLoaded: Function;
};

const CSS_TEXT = [
    {
        cssText: `
                #content > [class*="app___"] > [class*="footer___"],
                #content > [class*="app___"] > [class*="header___"] {
                    display: none;
                }
            `,
    },
];

const CheckoutPageHeaderMeta = ({ baseUrl, catalogId, setZipLoaded }: Props) => {
    const { formatMessage } = useIntl();
    const deployment = useAppSelector(getDeployment);
    const description = formatMessage({ id: 'checkout.page.description' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'checkout.page.title' }));
    const canonical = `${baseUrl}/checkout/${catalogId}`;

    const src =
        deployment === 'preprod' || deployment === 'prod'
            ? 'https://cdn.quadpay.com/v1/quadpay.js'
            : 'https://cdn-sandbox.quadpay.com/v1/quadpay.js';

    const { loading } = useScript({ src });
    const previousLoading = usePrevious(loading);

    React.useEffect(() => {
        if (previousLoading && !loading) {
            setZipLoaded();
        }
    }, [loading, previousLoading, setZipLoaded]);

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            style={CSS_TEXT}
            title={title}
        />
    );
};

export default CheckoutPageHeaderMeta;
